





































































import { Component } from 'vue-property-decorator'
import {Action, Getter} from "vuex-class";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import { CallSoundItem } from "@/store/call/sound/types";
import { notifyError, notifyDelete } from '@/utils/notify-helper';
import ImportCallSounds from "@/components/Templates/ImportCallSounds.vue";

@Component({components: {ImportCallSounds}, filters: {}})
export default class CallSounds extends BaseItemsPage<CallSoundItem> {
  @Getter("callSounds") callSounds: any;
  @Action("getCallSounds") actionGetCallSounds: any;
  @Action("deleteCallSound") actionDelete: any;
  private is_show_import = false;
  currentSort= "fileId";
  currentSortOrder= "desc";
  tableFields = [
    'fileId',
    'name',
    'patch',
  ];

  created() {
    try {
      this.actionGetCallSounds();
    } catch(error) {
      notifyError(error);
    }
  }

  getData(): any {
    return this.callSounds;
  }

  async onDeleteItem(item: CallSoundItem) {
    if (!await notifyDelete()) return
    try {
      await this.actionDelete({fileId: item.fileId})
      this.actionGetCallSounds();
    } catch (error) {
      notifyError(error);
    }
  }
}
